import LogoutLink from '@/common/components/LogoutLink/LogoutLink';

export default LogoutLink;
